import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Api from '../common/Api.js'

export default function Search(props) {
  const { categories } = props;
	const { states } = props;
  const navigate = useNavigate();
  const customer = JSON.parse(localStorage.getItem('login-token'));

  const [cities, setCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [search, setSearch] = useState({
    search: '',
    category: 0,
    state: null,   // { value: 'MH', label: 'Maharashtra' }
    city: '',      // city name or code
    customer: customer !== null ? customer.id : 0,
  });

  // 2️⃣ When state changes, fetch cities for that state
  useEffect(() => {
    if (!search.state) {
      setCities([]);
      return;
    }
    let cancelled = false;
    (async () => {
      setLoadingCities(true);
      try {
        const { data } = await Api.get('/home/cities', {
          params: { code: search.state.value },
        });
        if (!cancelled) {
          setCities(data.map(c => ({ value: c.name, label: c.name, code: c.id })));
        }
      } catch (err) {
        toast.error('Failed to load cities');
      } finally {
        if (!cancelled) setLoadingCities(false);
      }
    })();
    return () => { cancelled = true; };
  }, [search.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearch(prev => ({ ...prev, [name]: value }));
  };

  const handleState = (selected) => {
    // reset city when state changes
    setSearch(prev => ({ ...prev, state: selected, city: '' }));
  };

  const handleCity = (selected) => {
    setSearch(prev => ({ ...prev, city: selected?.value ?? '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (search.category === 0 && search.search === '' && search.city === '') {
      toast.error('Please select at least one input.');
      return;
    }
    // Convert to plain object for navigation state
    navigate('/shops', {
      state: {
        search: search.search,
        category: search.category,
        state_code: search.state?.value ?? '',
        city: search.city,
        customer: search.customer,
      },
    });
  };

	// At the top of the component (outside return)
const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 38,
    height: 38,
  }),
  valueContainer: (base) => ({
    ...base,
    flexWrap: 'nowrap',
    overflow: 'hidden',
  }),
  singleValue: (base) => ({
    ...base,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  }),
  placeholder: (base) => ({
    ...base,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
};

  return (
    <>
      <section className="w3l-search-form-3-main">
        <div className="search-form-3">
          <div className="wrapper">
            <div className="section-width">
              <form className="search-3-gd" onSubmit={handleSubmit}>
                {/* Pincode */}
                <div className="d-flex grids-icon">
                  <span className="fa fa-text-height" />
                  <input
                    type="search"
                    name="search"
                    value={search.search}
                    onChange={handleChange}
                    placeholder="Enter Pincode here.."
                  />
                </div>

                {/* Category */}
                <div className="d-flex grids-icon grids-icon-2">
                  <span className="fa fa-tags" />
                  <div className="input-group-btn">
                    <select
                      className="btn btn-default"
                      name="category"
                      value={search.category}
                      onChange={handleChange}
                      style={{ textAlign: 'justify' }}
                    >
                      <option value="all">Select Category</option>
                      {categories.map(c => (
                        <option key={c.id} value={c.id}>{c.name}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* State */}
                <div className="d-flex grids-icon grids-icon-2">
                  <span className="fa fa-map" />
                  <div className="input-group-btn">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
											styles={selectStyles}  
                      value={search.state}
                      onChange={handleState}
                      options={states}
                      placeholder="Search By State"
                      isClearable
                      isSearchable
                    />
                  </div>
                </div>

                {/* City — disabled until state picked */}
                <div className="d-flex grids-icon grids-icon-2">
                  <span className="fa fa-map-marker" />
                  <div className="input-group-btn">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
											styles={selectStyles}  
                      value={cities.find(c => c.value === search.city) || null}
                      onChange={handleCity}
                      options={cities}
                      isLoading={loadingCities}
                      isDisabled={!search.state}
                      placeholder={search.state ? 'Search By City' : 'Select state first'}
                      isClearable
                      isSearchable
                    />
                  </div>
                </div>

                <button type="submit" className="btn button-eff">
                  <span className="fa fa-search" />Search
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}